const isNewArrivals = (product) => {
  if (!product) return false
  if (!product.categories) return false
  return product.categories.some((category) => {
    return category.name === 'New Arrivals'
  })
}

export default isNewArrivals
